import "./styles.scss";

import React, { useState } from "react";
import { Link } from "gatsby";

import useTranslation from "locales";

const Newsletter = ({ lang, title, text }) => {
  const { t } = useTranslation(lang);
  const [email, setEmail] = useState("");
  const [legal1, setLegal1] = useState(false);
  const [legal2, setLegal2] = useState(false);

  return (
    <div id="newsletter" className="newsletterModal-component">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-7">
            <form
              className="content"
              method="post"
              action="https://app.freshmail.com/pl/actions/subscribe/"
            >
              <input
                type="hidden"
                name="subscribers_list_hash"
                value="o6zp22vfgl"
              />
              <div className="top">
                <div className="info">
                  <h2>{title}</h2>
                  <p>{text}</p>
                  <div className="row align-items-center">
                    <div className="col-md-7">
                      <div className="contact-form__input-group">
                        <input
                          type="email"
                          className="contact-form__input"
                          placeholder={`${t("Twój e-mail")}*`}
                          name="freshmail_email"
                          required
                          value={email}
                          id="phone"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md">
                      <button
                        type="submit"
                        className="contact-form__btn btn btn--white"
                        disabled={!legal1 || !legal2}
                      >
                        {t("Zapisz się")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bottom">
                <div className="contact-form__input-gropup">
                  <label className="checkbox-wrapper" htmlFor="acceptance1">
                    <input
                      type="checkbox"
                      name="acceptance1"
                      id="acceptance1"
                      onChange={() => setLegal1(!legal1)}
                    />
                    <span>
                      *
                      {t(
                        "Wyrażam zgodę na przesyłanie na podany przeze mnie adres poczty elektronicznej informacji handlowych na cele marketingu bezpośredniego, oraz cele związane z serwisem www i opieką nad zakupionymi biletami, zgodnie z przepisami ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną, przyjmując jednocześnie do wiadomości, że niniejsza zgoda może być zawsze odwołana."
                      )}
                    </span>
                  </label>
                </div>
                <div className="contact-form__input-gropup">
                  <label className="checkbox-wrapper" htmlFor="acceptance2">
                    <input
                      type="checkbox"
                      name="acceptance2"
                      id="acceptance2"
                      onChange={() => setLegal2(!legal2)}
                    />
                    <span>
                      *
                      {t(
                        "Wyrażając zgodę oświadczam, że zapoznałem się z treścią"
                      )}{" "}
                      <Link
                        to={t("/polityka-prywatnosci/")}
                        className="contact-form__yellow-hover"
                      >
                        {t("Polityki prywatności")}
                      </Link>
                    </span>
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-4 offset-md-1 text-center">
            <img
              className="img-fluid"
              src={require("assets/images/newsletter-fox-image.png").default}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
